import { render, staticRenderFns } from "./MeuRanking.vue?vue&type=template&id=4b0bba1c"
import script from "./MeuRanking.vue?vue&type=script&lang=js"
export * from "./MeuRanking.vue?vue&type=script&lang=js"
import style0 from "./MeuRanking.vue?vue&type=style&index=0&id=4b0bba1c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports